import React from "react";
import {
  TicketTypeSummaryProps
} from "../helpers/interfaceHelper";

const TicketTypeSummary: React.FC<TicketTypeSummaryProps> = ({
    count,
    name
}) => 
{
    return (
        <div style={{ borderRadius: '15px', border: '2px solid rgb(79, 189, 219)', width:'10%',  height:'100%', display: 'table-cell' }}>
            <div style={{ marginLeft: '2.5%', width:'100%'}}  >
                <h5>{name}</h5>
                <div style={{fontSize: '1.5em'}}>{count}</div>
            </div>
        </div>
    );
};

export default TicketTypeSummary;